module.exports = __webpack_public_path__ + "static/media/frame.5cac9571.svg";